<template lang="pug">
    section#instacart-share.share
      .share-container
        img(v-lazy="imgUrl" alt="Shopper with food" width="533" height="602")
        .share-container__text
          h3 Applaud <br/>the <span>shopper community</span>
          #lottie-share
          //img(src="@/assets/images/clapping-crop.gif" alt="Clapping animation")
          p Show your appreciation for the <br/>Instacart shopper community by sharing their incredible stories.
          button#instacart-share-modal(@click="showModal = !showModal") Share
          <!-- Modal-->
          transition(@enter='startTransitionModal' @after-enter='endTransitionModal' @before-leave='endTransitionModal' @after-leave='startTransitionModal')
            .modal.fade(v-if='showModal' ref='modal')
              .modal-dialog.modal-dialog-centered(role='document')
                .modal-content
                  .modal-body
                    button.close(type='button' @click='showModal = !showModal')
                      svg(width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg")
                        path(d="M12.0209 12.0208L0.7072 0.707107" stroke-linecap="round")
                        path(d="M12.0208 0.707107L0.707119 12.0208" stroke-linecap="round")
                    h3 Share 
                    .share-rrss
                      ul
                        //li
                          a(href="" ref="shareIG" target="_blank")
                            .svg
                              svg(viewBox="0 0 24 24")
                                path(d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z")
                            p Instagram
                        li
                          a(id="instacart-twitter-share" href="" ref="shareTW" target="_blank")
                            .svg
                              svg(viewBox="0 0 24 24")
                                path(d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z")
                            p Twitter
                        li
                          a(id="instacart-facebook-share" href="" ref="shareFB" target="_blank")
                            .svg
                              svg(viewBox="0 0 155.139 155.139")
                                path(d="M89.584,155.139V84.378h23.742l3.562-27.585H89.584V39.184 c0-7.984,2.208-13.425,13.67-13.425l14.595-0.006V1.08C115.325,0.752,106.661,0,96.577,0C75.52,0,61.104,12.853,61.104,36.452 v20.341H37.29v27.585h23.814v70.761H89.584z")
                            p Facebook
                        li
                          a(id="instacart-mail-share" href="" target="_blank" ref="shareEmail")
                            .svg
                              svg(viewBox="0 0 27 21")
                                path(d="M22.4558 0.360352H3.89442C1.81373 0.360352 0.124466 2.04962 0.124466 4.13031V17.0951C0.124466 19.1758 1.81373 20.8651 3.89442 20.8651H22.4558C24.5365 20.8651 26.2257 19.1758 26.2257 17.0951V4.13031C26.2189 2.04962 24.5296 0.360352 22.4558 0.360352ZM22.4558 2.15949C22.6069 2.15949 22.7579 2.18009 22.9021 2.21443L15.0738 11.1003C14.5931 11.6428 13.8996 11.9586 13.1785 11.9586C12.4506 11.9586 11.764 11.6496 11.2833 11.1003L3.45493 2.21443C3.59914 2.18009 3.75022 2.15949 3.90129 2.15949H22.4558ZM24.4197 17.0951C24.4197 18.1801 23.5408 19.0591 22.4558 19.0591H3.89442C2.80944 19.0591 1.93047 18.1801 1.93047 17.0951V4.13031C1.93047 3.86936 1.9854 3.61529 2.08154 3.38181L9.93047 12.2882C10.7545 13.2222 11.9356 13.7578 13.1785 13.7578C14.4215 13.7578 15.6026 13.2222 16.4266 12.2882L24.2755 3.38181C24.3717 3.60842 24.4197 3.8625 24.4197 4.12344V17.0951Z")
                            p Mail
                        li
                          a(id="instacart-link-share" href="" @click.prevent="clipboardData($event)" ref="copyLink")
                            .svg
                              svg(viewBox="0 0 26 26")
                                path(d="M6.7,25.3c-3.2,0-5.8-2.6-5.8-5.8c0-1.5,0.6-3,1.7-4.1L7.9,10C9,8.9,10.5,8.3,12,8.3c1.1,0,2.2,0.3,3.1,0.9 c0.4,0.2,0.7,0.5,1,0.8c0.3,0.3,0.5,0.8,0.5,1.3c0,0.4-0.2,0.8-0.5,1.1c-0.7,0.6-1.7,0.6-2.3,0c-1-1-2.6-1-3.5,0L5,17.7 c-1,1-1,2.6,0,3.5c1,1,2.6,1,3.5,0l3.1-3.1c0.1-0.1,0.3-0.2,0.5-0.1c0.8,0.3,1.8,0.5,2.7,0.5h0.2c0.2,0,0.4,0.2,0.4,0.4 c0,0.1,0,0.2-0.1,0.3l-4.4,4.4C9.7,24.7,8.3,25.3,6.7,25.3z M14.8,17.2L14.8,17.2h-0.3c-0.2,0-0.4,0-0.6-0.1c-0.2,0-0.3-0.1-0.5-0.1 L13.1,17c-0.1,0-0.2-0.1-0.3-0.1c-0.1,0-0.2-0.1-0.3-0.1c-0.1,0-0.2-0.1-0.3-0.1c-0.6-0.3-1.2-0.7-1.7-1.2c-0.3-0.3-0.5-0.8-0.5-1.3 c0-0.4,0.2-0.8,0.5-1.1c0.7-0.6,1.7-0.6,2.3,0c1,1,2.6,1,3.5,0l1.4-1.4l0,0l3.9-3.9c1-1,1-2.6,0-3.5c-1-1-2.6-1-3.5,0l-3.1,3.1 c-0.1,0.1-0.3,0.2-0.5,0.1c-0.8-0.3-1.7-0.5-2.7-0.5h-0.2c-0.2,0-0.3-0.1-0.4-0.3c-0.1-0.2,0-0.3,0.1-0.5L15.9,2 c2.3-2.3,6-2.3,8.2,0c2.3,2.3,2.3,6,0,8.2l-5.3,5.3c-0.7,0.7-1.7,1.3-2.7,1.5h0l-0.2,0l-0.1,0l-0.3,0h-0.1c-0.1,0-0.2,0-0.3,0 L14.8,17.2z")
                            p Copy Link

          .modal-backdrop.fade.d-none(ref='backdrop')

        
</template>
<script>
import img from '@/assets/images/share-image_v1.png';
import lottie from 'lottie-web';

export default {
  name: 'App',
  data(){
    return {
    showModal: false,
    imgUrl: img
    }
  },
  beforeMount(){
  
  },
  mounted(){
    this.loadLottie();
  },
  methods:{
    loadLottie(){
      const animClapping = {
        container: document.getElementById('lottie-share'),
        renderer: 'svg',
        loop: true,
        autoplay: true,
        path: 'clapping.json',
        // Path for production //
         // path: '/blog-nubank/wp-content/themes/nubankv2/quiz/animations/lamp.json'
      }
      lottie.loadAnimation(animClapping)
    },
    addShareURI(){
      //let shareLink = window.location.href;
      let shareLink = 'https://www.instacart.com/beyondthecart/';
      let fbShareLink = 'http://www.facebook.com/sharer/sharer.php?u='+shareLink;
      let twShareLink = 'http://twitter.com/intent/tweet?url=' + shareLink;
      let shareEmail = 'https://mail.google.com/mail/?view=cm&fs=1&to=someone@example.com&su=Share%20Instacart%20Beyond%20the%20cart&body='+shareLink+'';
      this.$refs.shareFB.href = fbShareLink;
      this.$refs.shareTW.href = twShareLink;
      this.$refs.copyLink.href = shareLink;
      this.$refs.shareEmail.href = shareEmail;
      
    },
    clipboardData(event){
      let link_site = event.target.href;
      document.addEventListener('copy', function(e) {
         e.clipboardData.setData('text/plain', link_site);
         e.preventDefault();
      }, true);

      document.execCommand('copy');
      this.$toast.open({
        message: 'Copied to clipboard',
        position: 'top',
        queue: true,
        duration: 3000
      });
      
    },
    startTransitionModal() {
      this.$refs.backdrop.classList.toggle("d-block");
      this.$refs.modal.classList.toggle("d-block");  
    },
    endTransitionModal() {
      this.$refs.backdrop.classList.toggle("show");
      this.$refs.modal.classList.toggle("show");
      this.addShareURI();
    },
  },
  components:{
  },
}

</script>
<style lang="scss">

.share{
  position: relative;
  width: 100%;
  min-height: 100vh;
  height: auto;
  background: $white;
  overflow: hidden;
  @media (min-width: 768px) and (max-width: 1024px) {
    min-height: auto;
  }
  @media (width: 768px){
    min-height: auto;
  }
  @media screen and (min-width: 1500px){
    min-height: auto;
  }
  /* &::before{
    content: '';
    position: absolute;
    top: -50%;
    width: 200%;
    height: 100%;
    left: -50%;
    border-radius: 50%;
    background-color: $soft_brown;
    @include respond-to('small'){  
      width: 100%;
      left: 0;
      top: -60%;
    }
  } */
  
  &-container{
    position: relative;
    z-index: 2;
    max-width: 800px;
    width: 100%;
    margin: 0 auto;
    display: block;
    left: 0;
    padding-bottom: 0;
    @include respond-to('mobile'){
      padding-bottom: 100px;
    }
    @include respond-to('small'){  
      left: -100px;
      padding-bottom: 50px;
    }
    > img{
      max-width: 100%;
      height: auto;
      display: block;
    }
    &__text{
      position: relative;
      right: 0;
      bottom: 0;
      max-width: 330px;
      width: 100%;
      margin: 0 auto 0;
      padding: 0 1rem;
      @include respond-to('small'){  
        position: absolute;
        right: 0;
        bottom: 0;
        width: 330px;
        max-width: inherit;
        margin: 0;
      }
      @media (min-width: 768px) and (max-width: 1024px) {
        bottom: 0;
      }
      @media (width: 768px){
        bottom: 0;
      }      
      h3{
        font-size:2.5rem;
        line-height: 1.25;
        color: $soft_green; 
        font-weight: 900;
        @include respond-to('mobile'){  
          font-size: 2.7rem;
        }
        @include respond-to('small'){  
          font-size: 2.8rem;
        }
        span{
          color: $orange;
        }
        
      }
      p{
        width: 200px;
        font-size: 0.9rem;
        color: $green;
      }
      #lottie-share{
        float: right;
        margin-top: -2rem;
        width: 80px;
      }
      img{
        float: right;
        margin-top: -2rem;
        width: 80px;
      }
      button{
        border: none;
        background: $soft_green;
        border-radius: 20px;
        padding: 0 1.5rem;
        text-align: center;
        color: $white;
      }
    }
  }
}

.modal{
  &-dialog{
    max-width: 330px;
  }
  &-content{
    border: none !important;
    background: $soft_green !important;
    border-radius: 40px !important;
  }
  &-body{
    button{
      position: absolute;
      padding: 0;
      background: transparent;
      color: $white;
      opacity: 1;
      width: 25px;
      height: 25px;
      right: 1rem;
      svg{
        width: 100%;
        stroke: $white;
      }
    }
    h3{
      color: $white;
      text-align: center;
      font-size: 1.5rem;
      margin-top: 1rem
    }
    .share-rrss{
      position: relative;
      ul{
        margin: 0;
        padding: 0;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
        list-style-type: none;
        li{
          width: 33.3333%;
          padding: 0 1rem;
          margin: 0.2rem 0;
          a{
            margin: 0 auto;
            display: block;
            position: relative;
            .svg{
              pointer-events: none;
              background: $white;
              border-radius: 50%;
              width: 50px;
              height: 50px;
              display: flex;
              justify-content: center;
              align-items: center;
              margin: 0 auto;
              svg{
                width: 30px;
                height: 30px;
                fill: $soft_green;
                
              }
            }
            p{
              text-align: center;
              color: $white;
              width: auto;
              font-size: 0.8rem;
              margin-top: 0.5rem;
            }
          }
        }
      }
    }
  }
}

.v-toast__item--success{
  background-color: $soft_green !important;
}
</style>
